import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { requestAuth } from "../../http/httpRequest";
import { toastOn } from "../../store/slices/toast";
import { TitleSection } from "./formularioDeCompra/aditionalComponents";
export const EfectivoTraspasosForm = ({ field, values, setValues }) => {
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const [listMainNames, setListMainNames] = useState([]);
  const [cantidadEgreso, setCantidadEgreso] = useState(0);
  const [cantidadRestante, setCantidadRestante] = useState(
    field.generalData?.monto_total || 0
  );
  const [errorDistribucion, setErrorDistribucion] = useState(false);
  // Dentro del componente principal
  const totalMonedasInputs = data.reduce((sum, item) => sum + item.monedas, 0);
  const totalBilletesInputs = data.reduce(
    (sum, item) => sum + item.billetes,
    0
  );

  const monedasRestantes =
    (field.generalData.monedas_total || 0) - totalMonedasInputs;
  const billetesRestantes =
    (field.generalData.billetes_total || 0) - totalBilletesInputs;

  const getData = async () => {
    console.log(field);
    await requestAuth("get", field?.urlApi, null)
      .then((response) => {
        setList(response.data);
        setData(
          response.data.map((s) => ({
            efectivo_id: s.id + "",
            monto_total: 0,
            billetes: 0,
            monedas: 0,
          }))
        );
        setListMainNames([
          ...new Set(response.data?.map((s) => s.mainNombre) ?? []),
        ]);
      })
      .catch((error) => {
        dispatch(
          toastOn({
            type: "danger",
            message:
              error?.response?.data?.message || "error a listar las casillas.",
          })
        );
      });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addData = (value, name, type) => {
    const newData = data.map((item) => {
      if (item.efectivo_id === name) {
        let monto_total = item.monto_total;
        let billetes = item.billetes;
        let monedas = item.monedas;

        const val = parseFloat(value) || 0;

        if (type === "monto_total") {
          monto_total = val;
          billetes = val;
          monedas = 0;
        } else if (type === "billetes") {
          if (monto_total <= 0) {
            billetes = 0;
            monedas = 0;
          } else {
            billetes = val;
            if (billetes > monto_total) billetes = monto_total;
            monedas = monto_total - billetes;
          }
        } else if (type === "monedas") {
          if (monto_total <= 0) {
            monedas = 0;
            billetes = 0;
          } else {
            monedas = val;
            if (monedas > monto_total) monedas = monto_total;
            billetes = monto_total - monedas;
          }
        }

        return { ...item, monto_total, billetes, monedas };
      }
      return item;
    });

    setData(newData);

    // Calculamos totales
    const totalCantidad = newData.reduce(
      (sum, item) => sum + item.monto_total,
      0
    );
    const totalBilletesInputs = newData.reduce(
      (sum, item) => sum + item.billetes,
      0
    );
    const totalMonedasInputs = newData.reduce(
      (sum, item) => sum + item.monedas,
      0
    );

    const montoRestante = (field.generalData?.monto_total || 0) - totalCantidad;
    const billetesRestantes =
      (field.generalData?.billetes_total || 0) - totalBilletesInputs;
    const monedasRestantes =
      (field.generalData?.monedas_total || 0) - totalMonedasInputs;

    // Estado booleano único para errores
    const error =
      montoRestante < 0 || billetesRestantes < 0 || monedasRestantes < 0;
    setErrorDistribucion(error); // estado interno
    setValues("errorDistribucion", error);
    setValues("dataList", newData);
    // Actualizamos estados visibles
    setCantidadEgreso(totalCantidad);
    setCantidadRestante(montoRestante);
  };

  return (
    <div className="col-start-1 col-end-13 dark:text-gray-100 bg-gray-100 dark:bg-gray-700 border border-gray-200 dark:border-gray-500 rounded p-3">
      <center className="font-semibold mb-2">{field.title}</center>
      <div className="flex flex-col mb-2 text-sm bg-gray-200 dark:bg-gray-800 p-2 rounded font-semibold dark:text-gray-300 text-gray-700">
        <div>
          {field.generalData?.nombre !== null ? (
            <>
              <span>Caja:</span>{" "}
              <span className="dark:text-blue-400 text-blue-600">
                {field.generalData?.nombre}
              </span>
            </>
          ) : (
            <>
              <span>Producto:</span>{" "}
              <span className="dark:text-blue-400 text-blue-600">
                {field.generalData?.Producto?.nombre}
              </span>
            </>
          )}
        </div>
        <div>
          <span>Monto actual:</span>{" "}
          <span className="dark:text-blue-400 text-blue-600">
            {field.generalData?.monto_total}
          </span>
        </div>
        <div>
          <span>Billetes:</span>{" "}
          {billetesRestantes < 0 ? (
            <span className="text-red-500">
              {field.generalData.billetes_total} - {totalBilletesInputs} (error
              al distribuir!)
            </span>
          ) : (
            <span>
              <span className="dark:text-blue-400 text-blue-600">
                {field.generalData.billetes_total}
              </span>{" "}
              - <span className="text-green-500">{totalBilletesInputs}</span>
            </span>
          )}
        </div>

        <div>
          <span>Monedas:</span>{" "}
          {monedasRestantes < 0 ? (
            <span className="text-red-500">
              {field.generalData.monedas_total} - {totalMonedasInputs} (error al
              distribuir!)
            </span>
          ) : (
            <span>
              <span className="dark:text-blue-400 text-blue-600">
                {field.generalData.monedas_total}
              </span>{" "}
              - <span className="text-green-500">{totalMonedasInputs}</span>
            </span>
          )}
        </div>

        <div>
          <span>Monto egreso:</span>{" "}
          <span className="dark:text-blue-400 text-blue-600">
            {cantidadEgreso}
          </span>
        </div>
        <div>
          <span>Monto restante:</span>{" "}
          <span className="text-green-500">{cantidadRestante}</span>{" "}
          {cantidadRestante < 0 && (
            <span className="text-red-500">error al distribuir!</span>
          )}
        </div>
      </div>
      {listMainNames && listMainNames.length > 0 ? (
        listMainNames.map((item, idx) => (
          <div
            key={idx}
            className="mb-2 p-1 border-2 border-gray-500 dark:border-gray-500 rounded-lg bg-gray-400 dark:bg-gray-600"
          >
            <div className="text-center">
              <TitleSection title={item} />
            </div>
            <SectionCards
              list={list.filter((l) => l.mainNombre === item)}
              field={field}
              data={data}
              addData={addData}
            />
          </div>
        ))
      ) : (
        <SectionCards list={list} field={field} addData={addData} data={data} />
      )}
    </div>
  );
};

const SectionCards = ({ list, addData, field, data }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 max-h-80 overflow-auto">
      {list?.map((i, index) => (
        <div
          key={index}
          className="dark:bg-gray-800 bg-gray-300 p-2 rounded-lg"
        >
          <div className="mb-2">
            {
              <label
                htmlFor={index}
                className="dark:text-gray-400 text-gray-800 font-semibold"
              >
                {i.nombre ?? i.Producto?.nombre}
              </label>
            }
          </div>
          <div>
            <input
              id={`${index}-monto`}
              type="number"
              name={i.id + ""}
              step="0.1"
              defaultValue={0}
              className={`shadow-sm outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 font-semibold disabled:opacity-55 disabled:text-gray-500 dark:disabled:text-gray-400 ${field.highlight}`}
              onChange={(e) =>
                addData(e.target.value, e.target.name, "monto_total")
              }
            />
            <label>Billetes</label>
            <input
              id={`${index}-billetes`}
              type="number"
              name={i.id + ""}
              value={
                data.find((d) => d.efectivo_id === i.id + "")?.billetes || 0
              }
              className={`shadow-sm outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 font-semibold disabled:opacity-55 disabled:text-gray-500 dark:disabled:text-gray-400 ${field.highlight}`}
              onChange={(e) =>
                addData(e.target.value, e.target.name, "billetes")
              }
            />
            <label>Monedas</label>
            <input
              id={`${index}-monedas`}
              type="number"
              step="0"
              name={i.id + ""}
              value={
                data.find((d) => d.efectivo_id === i.id + "")?.monedas || 0
              }
              className={`shadow-sm outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 font-semibold disabled:opacity-55 disabled:text-gray-500 dark:disabled:text-gray-400 ${field.highlight}`}
              onChange={(e) =>
                addData(e.target.value, e.target.name, "monedas")
              }
            />
          </div>
        </div>
      ))}
    </div>
  );
};
